// © 2025 Ananda Kumar. All rights reserved.
// Unauthorized copying of this file, via any medium, is strictly prohibited.

import { Injectable } from "@angular/core";

@Injectable({
  providedIn: 'root',
})
export class DeviceService {
  constructor() {}

  async getDeviceInfo(): Promise<string> {
    return await this.invokeMauiMethod('GetDeviceInfo');
  }

  async getLocation(): Promise<string> {
    return await this.invokeMauiMethod('GetLocation');
  }

  private invokeMauiMethod(methodName: string): Promise<string> {
    return new Promise((resolve, reject) => {
      (window as any).receiveResultFromMaui = (result: string) => {
        resolve(result);
      };

      window.location.href = `maui://${methodName}`;
    });
  }
}